import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserId, setUserProperties, Analytics } from "firebase/analytics";
import { getConfig } from "src/config/Config";
import { User } from "src/types/commonTypes";
import { ANALYTICS_PII_KEYS } from "src/components/constant/constant";

let analyticsInstance: Analytics | null = null;

export function getAnalyticsInstance(): Analytics {
  if (analyticsInstance) return analyticsInstance;
  const config = getConfig();
  const firebaseApp = initializeApp(config.FIREBASE_CONFIG);

  analyticsInstance = getAnalytics(firebaseApp);
  return analyticsInstance;
}

export const logScreenView = (screenName: string) => {
  logEvent(getAnalyticsInstance(), "screen_name", {
    screen_name: screenName
  });
};

export const logUserInteraction = (interactionName: string, details: Record<string, any> = {}) => {
  const safeDetails = Object.fromEntries(
    Object.entries(details).filter(([key]) => !ANALYTICS_PII_KEYS.includes(key.toLowerCase()))
  );

  logEvent(getAnalyticsInstance(), interactionName, safeDetails);
};

export const setUserDetail = (user: User, organisationId?: string, callback?: () => void) => {
  setUserId(getAnalyticsInstance(), user?.id);
  setUserProperties(getAnalyticsInstance(), {
    ...(organisationId && { organisationId })
  });

  if (callback) {
    callback();
  }
};

export const removeUserDetail = () => {
  setUserId(getAnalyticsInstance(), null);
  setUserProperties(getAnalyticsInstance(), {
    organisationId: null
  });
};
